export default __webpack_public_path__ + "static/media/card-profile2-square.2868d711.jpg";